/**
 * Returns whether the current build is not meant for production
 */
export const isNonProductionBuild = () =>
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
